export default __webpack_public_path__ + "static/gitkraken_account2-dfea34d3943c000717855ebea4a37757.png";